const DEFAULT_IMAGE_BASE_URL = 'https://www.gdcdb.net/images/';

const normalizeBaseUrl = (url) => {
    const value = url || DEFAULT_IMAGE_BASE_URL;
    return value.endsWith('/') ? value : `${value}/`;
};

const IMAGE_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_IMAGE_BASE_URL);

const joinImageUrl = (folder, fileName) => {
    const cleanFolder = String(folder || '').replace(/^\/+|\/+$/g, '');
    const cleanFileName = String(fileName || '').replace(/^\/+/g, '');
    return `${IMAGE_BASE_URL}${cleanFolder}/${cleanFileName}`;
};

export const getDensityImageUrl = (gene) => joinImageUrl('density', `${gene}.png`);

export const getMouseExpressionImageUrl = (gene) => {
    const name = gene ? `${gene.charAt(0).toUpperCase()}${gene.slice(1).toLowerCase()}` : '';
    return joinImageUrl('mouse', `${name}_umap.png`);
};

export const getMacacaExpressionImageUrl = (gene) => {
    const name = gene ? gene.toUpperCase() : '';
    return joinImageUrl('macaca', `${name}.png`);
};
